import fromPairs from 'lodash/fromPairs'
import get from 'lodash/get'
import toPairs from 'lodash/toPairs'
import * as AppTypes from '../../app/types'
import * as IsActive from '../../components/is_active/types'
import * as RasaInput from '../../components/rasa-input'
import * as Constants from './constants'
import * as Types from './types'

export const selectedCommunityName =
  (app: AppTypes.State, communities: Types.Communities): Types.CommunityName => {
    const selected = communities[app.selectedCommunity]
    return selected ? selected.name : ''
}

export const config = (key: string, configs: Types.CommunityConfigs): Types.ConfigRow[] => {
  return toPairs<Types.EditableConfigRow>(configs)
           .filter((x: [string, Types.EditableConfigRow]) => x[1].data.key === key)
           .map((x: [string, Types.EditableConfigRow]) => x[1].data)
}

export const configsFromResponse = (payload: any): Types.ConfigRow[] => {
  return payload instanceof Array ? payload : payload.configs
}

export const partnerCodesAsDropdownOptions = (data: string[]): RasaInput.DropdownOption[] => {
  if (data.length === 0) {
    return []
  } else {
    return [{key: '', description: Constants.DEFAULT_PARTNER_CODE}].concat(
      data.map((s: string) => ({key: s, description: s})))
  }
}

export const communitiesFromPayload = (payload: any): Types.Communities => {
  return fromPairs((payload || []).map((community: Types.Community) => ([community.identifier, community])))
}

export const filterParametersByConfig =
  (filters: IsActive.Filter[],
   communityConfig: Types.State,
   communityConfigfilterKey: string,
   filterValue: string): IsActive.Filter[] => {
  const configuration = communityConfig.gridState.filter((keyObj) => {
    return keyObj.data.key === communityConfigfilterKey
  });
  const newFilters = filters.filter((filter) => {
    return filter.value !== filterValue
  })
  return get(configuration[0], 'data.value') === 'false' ? newFilters : filters
}



// WEBPACK FOOTER //
// ./src/pages/community-config/utils.ts